"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Camera = function Camera() {
  return _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    r: "2.64",
    cy: "6.596",
    cx: "6.875",
    strokeWidth: ".6"
  }), _react["default"].createElement("ellipse", {
    ry: ".687",
    rx: ".697",
    cy: "4.396",
    cx: "11.53",
    strokeWidth: ".5"
  }), _react["default"].createElement("path", {
    d: "M13.35 10.25c0 .338-.277.614-.616.614H1.016A.616.616 0 0 1 .4 10.25v-7c0-.339.276-.615.615-.615h2.342c.11 0 .212-.06.267-.156L4.63.705A.658.658 0 0 1 5.2.374h3.38c.236 0 .454.127.57.33l1.006 1.774a.307.307 0 0 0 .267.156h2.311c.34 0 .615.276.615.615z",
    strokeWidth: ".5"
  }));
};

var _default = (0, _createSvgIcon["default"])(Camera, {
  viewBox: '0 0 14 12',
  enableStroke: true
});

exports["default"] = _default;